/* eslint  no-sequences:0 */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';
import { call } from '../utils';

import styles from './FileDropZone.less';

const cxb = cx.bind(styles);

const stop = (e) => (e.preventDefault(), e.stopPropagation());

/**
 * **Access:**
 * ```js
 * import { FileDropZone } from '@iss/client-react-components'
 * ```
 *
 */
export default class FileDropZone extends React.Component {
  static propTypes = {
    /** A custom message to display in the center */
    promptMessage: PropTypes.node,

    /** a callback to invoke when a file has been selected or dropped */
    onSelect: PropTypes.func,
  };

  ref = React.createRef();

  state = {
    dragging: false,
    over: false,
  };

  get supportsDrop() {
    const div = this.div || (this.div = document.createElement('div'));
    return 'draggable' in div || ('ondragstart' in div && 'ondrop' in div);
  }

  componentDidMount() {
    document.addEventListener('dragover', this.onDragOver);
  }

  componentWillUnmount() {
    clearTimeout(this.stopOver);
    document.removeEventListener('dragover', this.onDragOver);
  }

  resetDrag = () => {
    this.setState({ dragging: false, over: false });
  };

  onDragOver = (e) => {
    const { current: el } = this.ref;

    this.setState({ dragging: true, over: el.contains(e.target) });

    clearTimeout(this.stopOver);

    this.stopOver = setTimeout(this.resetDrag, 500);
  };

  onSelect = (e) => {
    stop(e);

    let files = (e.target || e.dataTransfer || {}).files;

    if (!files || files.length === 0) {
      files = (e.dataTransfer || {}).files;
    }

    call(this.props.onSelect, e, files);
  };

  render() {
    const {
      props: { promptMessage },
      state: { dragging, over },
    } = this;

    const stops = {
      onDrag: stop,
      onDragStart: stop,
      onDragEnd: stop,
      onDragOver: stop,
      onDragEnter: stop,
      onDragLeave: stop,
      onDrop: this.onSelect,
    };

    return (
      <div className={cxb('root', { over })} ref={this.ref}>
        <input type="file" onChange={this.onSelect} {...stops} />

        {dragging ? (
          <Type className={cxb('drop-here')}>Drag your file here</Type>
        ) : promptMessage ? (
          promptMessage
        ) : (
          <Type>
            {this.supportsDrop ? (
              <>
                <b>Drag a file</b> here or <a href="#pick">choose a file</a> to upload.
              </>
            ) : (
              <>
                <a href="#pick">Choose a file</a> to upload.
              </>
            )}
          </Type>
        )}
      </div>
    );
  }
}
